import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { KmSelectComponent } from 'src/app/_components/remote-action-step/km-select/km-select.component';

@Injectable()
export class KmSelectRemoteActionBuilderUiStep
  implements GenericRemoteActionBuilderUIStep {
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(this.constructor.name, '- getComponent called');
    return KmSelectComponent;
  }

   public isVisible(currentData: any): boolean {
    if (currentData && currentData.dpflag === "dpp") {
      // Do not show KM if user is only a passenger
      return false;
    } else {
      return true;
    }
  }
}
